export const mapCommPref = (
  commPref: string | undefined,
  isInBranch: boolean,
  isOnline: boolean,
): string | undefined => {
  if (isInBranch) return 'in person';
  if (isOnline && commPref === 'Email') return 'email';
  if (isOnline) return 'phone';
  return undefined;
};
